import React, { useEffect } from 'react'
import sharedClasses from './signup.module.css'
import classes from './SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../assets/images/Login.jpg'
import logo from '../../assets/images/new-logo.png'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { Link, useHistory } from 'react-router-dom'
import { login, sendResetLink } from '../../api/authApi'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import * as yup from 'yup'
import { getParentRoute } from '../../util/functions'
import { authSelectors } from '../../redux/authSlice'
import notification from '../../components/Notification/notification'

const forgotPasswordSchema = yup.object({
    email: yup
        .string()
        .email('Please input a valid email')
        .required('Please input your email'),
})

function ForgotPassword({ location }) {
    const dispatch = useDispatch()
    const hasError = useSelector(authSelectors.getHasErrorState)
    const errorMessage = useSelector(authSelectors.getErrorMessageState)
    const success = useSelector(authSelectors.getSuccessState)
    const history = useHistory()

    const path = getParentRoute(location.pathname)

    const submitForm = async values => {
        const [dismiss] = await notification.loading({
            title: 'Submitting...',
        })
        await dispatch(sendResetLink(values))
        dismiss()
    }

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    useEffect(() => {
        if (success) {
            notification.success({
                title: 'Success',
                description:
                    'Password reset instructions have been sent to your mail',
            })
        }
    }, [success])

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            <Formik
                initialValues={{
                    email: '',
                }}
                onSubmit={submitForm}
                validationSchema={forgotPasswordSchema}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <img
                            src={logo}
                            alt="SME Upturn"
                            className={sharedClasses.formLogo}
                            onClick={() => history.push('/')}
                        />
                        <h1 className={sharedClasses.formHeader}>
                            Forgot Password
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            onClick={handleSubmit}
                        >
                            Submit
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Back to{' '}
                            <Link
                                onClick={() => history.goBack()}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt=""
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default ForgotPassword
